import React from 'react';

import Record from 'ui/Record/Record';

import { useNavBarHeight } from 'utils/hooks/navbar';

import PipelinesList from './components/PipelinesList';
import PipelinesHeader from './components/PipelinesHeader';

const Pipelines = (): React.ReactElement => {
  const navBarHeight = useNavBarHeight();
  const refreshRef = React.useRef<Function | null>(null);

  const onRefreshCallback = (callback: Function): void => {
    refreshRef.current = callback;
  };

  return (
    <Record
      navBarHeight={navBarHeight}
      Content={(onError) => <PipelinesList onError={onError} onRefreshCallback={onRefreshCallback} />}
      Header={<PipelinesHeader refreshRef={refreshRef} />}
    />
  );
};

export default Pipelines;
